import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import { FilterPicker, KeyboardDatePicker, MenuItem, Select, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { formatNumericUSDate } from '~/utils';
import { DateRange } from '../types';
import styles from './DateRangeWithPresets.module.scss';
import { calculateEndDate, calculateStartDate, dateRangePresetsTextsPath, getDataRangeNames, getDateRangeOptions } from './DateRangeWithPresets.utils';
const DateRangeWithPresets = (props)=>{
    var _props_customDateLimits, _props_customDateLimits1, _props_customDateLimits2, _props_customDateLimits3, _props_customDateLimits4, _props_customDateLimits5, _props_customDateLimits6;
    const { t: dateRangePresetsTexts } = useLocaleKeys(dateRangePresetsTextsPath);
    const [endDate, setEndDate] = useState(props.endDate);
    const [startDate, setStartDate] = useState(props.startDate);
    const [dataRangeOption, setDataRangeOption] = useState(props.dataRangeOption || DateRange.Last12Months);
    const dateRangeOptions = getDateRangeOptions(dateRangePresetsTexts);
    const dataRangeNames = getDataRangeNames(dateRangePresetsTexts);
    const updateDataRangeOption = (nextDataRangeOption)=>{
        const startDate = calculateStartDate(formatNumericUSDate(props.now), nextDataRangeOption, props.now);
        const endDate = calculateEndDate(formatNumericUSDate(props.now), nextDataRangeOption, props.now);
        setDataRangeOption(nextDataRangeOption);
        setStartDate(startDate);
        setEndDate(endDate);
    };
    return /*#__PURE__*/ _jsxs(FilterPicker, {
        startOpen: props.startOpen,
        removable: props.removable,
        onRemove: props.onRemove,
        testId: "".concat(props.testIdPrefix, "-data-range-picker"),
        label: dataRangeNames[dataRangeOption](startDate, endDate),
        title: props.title,
        highlightTrigger: false,
        popoverWidth: 380,
        onApply: ()=>props.onApply(dataRangeOption, startDate, endDate),
        onClose: ()=>{},
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames(styles.row, styles.rangePicker),
                children: [
                    /*#__PURE__*/ _jsx(Select, {
                        bi: {
                            name: 'date_range_preset'
                        },
                        collapseHelperText: false,
                        className: styles.dataRangeDropdown,
                        value: dataRangeOption,
                        onChange: (e)=>updateDataRangeOption(e.target.value),
                        testId: "revenue-breakdown-report-data-range-dropdown",
                        children: dateRangeOptions.map((param, idx)=>{
                            let { value, text } = param;
                            return /*#__PURE__*/ _jsx(MenuItem, {
                                value: value,
                                testId: "revenue-breakdown-report-data-range-option-".concat(idx),
                                children: text
                            }, value);
                        })
                    }),
                    ![
                        DateRange.AllTime,
                        DateRange.Custom
                    ].includes(dataRangeOption) && /*#__PURE__*/ _jsxs(Typography, {
                        testId: "revenue-breakdown-report-data-range-helper-text",
                        variant: "paragraph1",
                        noWrap: true,
                        children: [
                            startDate,
                            " - ",
                            endDate
                        ]
                    })
                ]
            }),
            dataRangeOption === DateRange.Custom ? /*#__PURE__*/ _jsxs("div", {
                className: styles.row,
                children: [
                    /*#__PURE__*/ _jsx(KeyboardDatePicker, {
                        bi: {
                            name: 'report_start_date'
                        },
                        testId: "revenue-breakdown-report-data-range-start-date-picker",
                        className: styles.customDatePicker,
                        value: startDate,
                        onChange: (date)=>{
                            if (date != null) {
                                setStartDate(formatNumericUSDate(date));
                                if (endDate == null || date > new Date(endDate)) {
                                    setEndDate(formatNumericUSDate(date));
                                }
                            }
                        },
                        minDate: ((_props_customDateLimits = props.customDateLimits) === null || _props_customDateLimits === void 0 ? void 0 : _props_customDateLimits.min) || new Date('2023-01-01'),
                        maxDate: (_props_customDateLimits1 = props.customDateLimits) === null || _props_customDateLimits1 === void 0 ? void 0 : _props_customDateLimits1.max,
                        minDateMessage: (_props_customDateLimits2 = props.customDateLimits) === null || _props_customDateLimits2 === void 0 ? void 0 : _props_customDateLimits2.minDateMessage,
                        maxDateMessage: (_props_customDateLimits3 = props.customDateLimits) === null || _props_customDateLimits3 === void 0 ? void 0 : _props_customDateLimits3.maxDateMessage
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        noWrap: true,
                        children: "\xa0-\xa0"
                    }),
                    /*#__PURE__*/ _jsx(KeyboardDatePicker, {
                        bi: {
                            name: 'report_end_date'
                        },
                        testId: "revenue-breakdown-report-data-range-end-date-picker",
                        className: styles.customDatePicker,
                        value: endDate,
                        onChange: (date)=>date != null && setEndDate(formatNumericUSDate(date)),
                        minDate: startDate,
                        maxDate: (_props_customDateLimits4 = props.customDateLimits) === null || _props_customDateLimits4 === void 0 ? void 0 : _props_customDateLimits4.max,
                        minDateMessage: (_props_customDateLimits5 = props.customDateLimits) === null || _props_customDateLimits5 === void 0 ? void 0 : _props_customDateLimits5.minDateMessage,
                        maxDateMessage: (_props_customDateLimits6 = props.customDateLimits) === null || _props_customDateLimits6 === void 0 ? void 0 : _props_customDateLimits6.maxDateMessage
                    })
                ]
            }) : null
        ]
    });
};
export default DateRangeWithPresets;
